import { useCallback, useMemo } from 'react';
import { ApolloError, FetchResult } from '@apollo/client';
import {
  PutAutoAcceptSettingInput,
  PutAutoAcceptSettingsMutation,
  usePutAutoAcceptSettingsMutation
} from 'graphql/types';

export const usePutAutoAcceptSettings = (): {
  putAutoAcceptSettings: (
    input: PutAutoAcceptSettingInput
  ) => Promise<
    FetchResult<
      PutAutoAcceptSettingsMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    putAutoAcceptSettingsMutation,
    { loading, error }
  ] = usePutAutoAcceptSettingsMutation();

  const putAutoAcceptSettings = useCallback(
    async (input: PutAutoAcceptSettingInput) =>
      await putAutoAcceptSettingsMutation({
        variables: {
          input
        }
      }),
    [putAutoAcceptSettingsMutation]
  );

  return useMemo(
    () => ({
      putAutoAcceptSettings,
      loading,
      error
    }),
    [putAutoAcceptSettings, loading, error]
  );
};
